import React from 'react';
import { 
  TextField, 
  InputAdornment, 
  Button 
} from '@mui/material';

/**
 * Reusable search bar component with "Find New" button
 * @param {Object} props - Component props
 * @param {string} props.searchQuery - Current search query
 * @param {function} props.handleSearchChange - Function to handle search input changes
 * @param {function} props.handleSearchKeyPress - Function to handle key press events
 * @param {function} props.handleSearch - Function to handle search submission
 * @param {string} props.placeholder - Placeholder text for search input
 * @param {Object} props.sx - Additional styling
 * @returns {JSX.Element} Search bar component
 */
const SearchBar = ({ 
  searchQuery, 
  handleSearchChange, 
  handleSearchKeyPress, 
  handleSearch,
  onScanBarcode,
  placeholder = "Search your collection or find new items...",
  sx = {}
}) => {
  return (
    <TextField
      fullWidth
      label="Search"
      value={searchQuery}
      onChange={handleSearchChange}
      onKeyPress={handleSearchKeyPress}
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Button
              onClick={handleSearch}
              disabled={!searchQuery.trim()}
              size="small"
              color="primary"
            >
              Find New
            </Button>
            {onScanBarcode && (
              <Button
                onClick={onScanBarcode}
                size="small"
                color="primary"
              >
                Scan
              </Button>
            )}
          </InputAdornment>
        ),
      }}
      sx={{ ...sx }}
    />
  );
};

export default SearchBar;
